module.exports = __webpack_public_path__ + "media/images/view-edit-9dbbbc6b93f8d2a6c908d1527dbb8a77.svg";